/* THIS FILE IS GENERATED. DO NOT EDIT IT. */
import * as React from 'react';

function SvgMicOff(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      width={24}
      height={24}
      fill='none'
      viewBox='0 0 24 24'
      {...props}
    >
      <g>
        <path
          fill='currentColor'
          fillRule='evenodd'
          d='M9.776.98a3.75 3.75 0 015.654 1.503c.241.545.313 1.106.332 1.612.01.3.003.642-.004.947-.004.169-.008.327-.008.46v3.84a.75.75 0 01-1.5 0v-3.84c0-.216.005-.404.01-.583.006-.26.013-.498.003-.768-.016-.415-.072-.762-.205-1.062a2.251 2.251 0 00-4.263.462.75.75 0 01-1.47-.299A3.75 3.75 0 019.775.98zM.47.47a.75.75 0 011.06 0l15.814 15.814a.75.75 0 01.323.323l5.863 5.863a.75.75 0 11-1.06 1.06l-5.518-5.517a7.75 7.75 0 01-4.202 1.752v2.486H16a.75.75 0 010 1.5H8a.75.75 0 010-1.5h3.25v-2.486a7.75 7.75 0 01-7-7.767V10a.75.75 0 111.5 0v2.006a6.25 6.25 0 005.991 6.29.748.748 0 01.518 0 6.246 6.246 0 003.627-1.35l-1.82-1.819a3.75 3.75 0 01-5.816-3.126v-2.69L.47 1.532a.75.75 0 010-1.06zm9.28 10.341v1.189a2.25 2.25 0 003.218 2.029L9.75 10.812zM19 9.252a.75.75 0 01.75.75v2c0 .456-.041.912-.122 1.362a.75.75 0 11-1.476-.265c.065-.362.098-.73.098-1.098v-2a.75.75 0 01.75-.75z'
        />
      </g>
      <defs>
        <clipPath id='mic-off_svg__clip0_126_10356'>
          <path fill='#fff' d='M0 0h24v24H0z' />
        </clipPath>
      </defs>
    </svg>
  );
}

export default SvgMicOff;
